export default function EsteroFinalCTA() {
  return (
    <section className="py-16 md:py-20 bg-[#1A365D]">
      <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
        <h2 className="font-serif text-2xl md:text-4xl font-bold text-white mb-4">
          Ready to Get Your Passport?
        </h2>
        <p className="text-white/70 text-sm md:text-base leading-relaxed mb-8 max-w-2xl mx-auto">
          Whether you are an FGCU student with a study abroad deadline, a snowbird heading north for the summer, or a family planning your first international trip — we will get your passport processed fast, correctly, and with zero stress.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Start My Application <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold text-base px-6 py-4 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line text-[#F6C344]"></i> 877-253-0084
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mt-10">
          {[
            "Registered State Department Courier",
            "A+ BBB Rated",
            "24-Hour Emergency Service",
            "Serving All of Lee County",
          ].map((badge, i) => (
            <div key={i} className="flex items-center gap-2 text-white/50 text-xs">
              <i className="ri-check-line text-[#F6C344]"></i>
              <span>{badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}